
const columns = [
    {
        title: "تاریخ ثبت",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 130,
        sorter: true,
      },
  {
    title: "تاریخ پرداخت",
    dataIndex: "paidAt",
    key: "paidAt",
    width: 130,
    sorter: true,
  },
  {
    title: "تاریخ لغو",
    dataIndex: "cancelAt",
    key: "cancelAt",
    width: 130,
    sorter: true,
  },
  {
    title: "مبلغ فاکتور (ریال)",
    dataIndex: "amountRial",
    key: "amountRial",
    width: 140,
    sorter: true
  },
  {
    title: "مبلغ قابل پرداخت (ریال)",
    dataIndex: "finalAmount",
    key: "finalAmount",
    width: 150,
    sorter: true
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 100,
  },
];

export default columns;
